module.exports = __webpack_public_path__ + "img/buy_super_ph.f806076b.png";